import Checkbox, { CheckboxProps } from "@/shared/form/checkbox";
import { useAllDynamicProcessCandidates } from "../../../model/use-all-dynamic-process-candidates";
import Form from "@/shared/form/form";
import { useEffect } from "react";

type FieldsProps = CheckboxProps & {
  onChange?: (values: string[]) => void;
  isEditMode?: boolean;
};

export function Fields({ onChange, isEditMode, ...rest }: FieldsProps) {
  const { data } = useAllDynamicProcessCandidates();
  const form = Form.useFormInstance();
  const metaClass = Form.useWatch("metaClass", form);

  const fields = data?.getAllDynamicProcessCandidates.find(
    (item) => item.id === metaClass,
  )?.fields;

  useEffect(() => {
    if (isEditMode) {
      return;
    }

    form.setFieldValue(
      "fields",
      fields?.filter((item) => item.required).map((item) => item.name) || [],
    );
  }, [fields, form, isEditMode]);

  return (
    <Checkbox.Group
      disabled={isEditMode}
      className="grid gap-y-3"
      options={(fields ?? [])
        .map(({ caption, name, required }) => ({
          label: caption,
          disabled: required,
          required,
          value: name,
        }))
        .sort((a) => (a.required ? -1 : 1))}
      onChange={(values) => {
        onChange?.(values);
      }}
      {...rest}
    />
  );
}
